"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var I18n = require("i18n-js");
var React = require("react");
var lodash_1 = require("lodash");
var core_link_1 = require("@reverbdotcom/commons/dist/components/core_link");
var listing_1 = require("./listing");
var overflowing_row_1 = require("@reverbdotcom/commons/dist/components/overflowing_row");
var tiles_1 = require("@reverbdotcom/commons/dist/components/tiles");
var listing_card_1 = require("./listing_card");
var tracker_1 = require("@reverbdotcom/commons/dist/tracker");
var RListingCard = listing_card_1.default;
var ListingRow = /** @class */ (function (_super) {
    tslib_1.__extends(ListingRow, _super);
    function ListingRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ListingRow, "defaultProps", {
        get: function () {
            return {
                trackName: 'ListingRow',
                expectedCount: 6,
                largeTiles: false,
                centered: false,
            };
        },
        enumerable: true,
        configurable: true
    });
    ListingRow.prototype.componentDidMount = function () {
        this.trackView();
    };
    ListingRow.prototype.componentDidUpdate = function (prevProps) {
        var listingIds = this.listingIds(this.props.listings);
        var prevListingIds = this.listingIds(prevProps.listings);
        if (lodash_1.isEqual(listingIds, prevListingIds)) {
            return;
        }
        this.trackView();
    };
    ListingRow.prototype.listingIds = function (listings) {
        if (!listings) {
            return [];
        }
        return listings.map(function (l) { return l.id; });
    };
    ListingRow.prototype.trackView = function () {
        if (!this.listingsLoaded) {
            return;
        }
        if (this.notEnoughListings) {
            return;
        }
        tracker_1.trackView({
            componentName: this.props.trackName,
            type: tracker_1.LISTING_TYPE,
            ids: this.listingIds(this.listings()),
            context: this.props.trackContext,
        });
    };
    Object.defineProperty(ListingRow.prototype, "listingsLoaded", {
        get: function () {
            // empty array counts as loaded
            return !!this.props.listings;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListingRow.prototype, "notEnoughListings", {
        get: function () {
            return this.listingsLoaded
                && this.props.minListings
                && this.props.listings.length < this.props.minListings;
        },
        enumerable: true,
        configurable: true
    });
    ListingRow.prototype.listings = function () {
        if (this.listingsLoaded) {
            return this.props.listings.slice(0, this.props.expectedCount);
        }
        return [];
    };
    ListingRow.prototype.collectionCount = function () {
        if (this.props.listings) {
            return this.props.listings.length;
        }
        return this.props.expectedCount;
    };
    ListingRow.prototype.shouldRenderLink = function () {
        return this.props.ctaTarget && (this.props.alwaysShowCTA ||
            (this.props.totalListings && this.props.totalListings > this.props.expectedCount));
    };
    ListingRow.prototype.renderAction = function () {
        if (!this.shouldRenderLink()) {
            return null;
        }
        return (React.createElement(core_link_1.default, { to: this.props.ctaTarget, trackName: this.props.trackName }, this.props.ctaText || I18n.t('discovery.listingsRow.seeMore')));
    };
    ListingRow.prototype.renderTitle = function () {
        if (this.props.titleElement) {
            return this.props.titleElement;
        }
        if (this.shouldRenderLink()) {
            return (React.createElement(core_link_1.default, { to: this.props.ctaTarget, trackName: this.props.trackName }, this.props.title));
        }
        return this.props.title;
    };
    ListingRow.prototype.renderListingViews = function () {
        var _this = this;
        if (!this.listingsLoaded) {
            return [];
        }
        return this.props.listings.map(function (listingJson, index) {
            var listing = new listing_1.default(listingJson);
            return (React.createElement(RListingCard, { key: listing.id, listing: listing, position: index + 1, trackName: _this.props.trackName, trackContext: _this.props.trackContext }));
        });
    };
    ListingRow.prototype.renderTiles = function () {
        return (React.createElement(tiles_1.default, { placeholder: React.createElement(listing_card_1.default, { listing: null }), loading: !this.listingsLoaded, expectedCount: this.props.expectedCount, singleRow: true, largeTiles: this.props.largeTiles, centered: this.props.centered }, this.renderListingViews()));
    };
    ListingRow.prototype.render = function () {
        if (this.props.error) {
            return null;
        }
        if (this.notEnoughListings) {
            return null;
        }
        return (React.createElement(overflowing_row_1.default, { title: this.renderTitle(), action: this.renderAction(), collectionCount: this.collectionCount(), centeredTitle: this.props.centered }, this.renderTiles()));
    };
    return ListingRow;
}(React.Component));
exports.default = ListingRow;
//# sourceMappingURL=listing_row.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/listing_row.js
// module id = ijd/
// module chunks = 20 21